import { CheckCircle, Clock, PlayCircle } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { getWorkflowStepTransitionState } from '@/lib/workflow/stepState'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface WorkflowStepNavigationProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function WorkflowStepNavigation({ workflow }: WorkflowStepNavigationProps) {
  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle className="text-base">Workflow Steps</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {workflow.steps.map((step, index) => {
          const transition = getWorkflowStepTransitionState({
            stepId: step.id,
            completedStepIds: workflow.completedSteps,
            currentStepId: workflow.current?.id,
          })

          return (
            <button
              key={step.id}
              onClick={() => workflow.setCurrentStep(index)}
              className={cn(
                'w-full text-left px-3 py-2 rounded-lg border text-sm transition-colors',
                index === workflow.currentStep
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-border hover:bg-muted/40'
              )}
            >
              <div className="flex items-center gap-2">
                {transition.indicator === 'completed' ? (
                  <CheckCircle className="h-4 w-4 text-emerald-500" />
                ) : transition.indicator === 'active' ? (
                  <PlayCircle className="h-4 w-4 text-primary" />
                ) : (
                  <Clock className="h-4 w-4 text-muted-foreground" />
                )}
                <span>{step.label}</span>
              </div>
            </button>
          )
        })}
      </CardContent>
    </Card>
  )
}
